import { Row, Col, Form, Button, Modal, Table } from 'react-bootstrap';
import { useState } from 'react';
import { useEffect } from 'react';
import Swal from "sweetalert2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrashCan  } from "@fortawesome/free-solid-svg-icons";
import Select from 'react-select';
import { useLocation } from "react-router-dom";


const EditSerialModal = ({ show, requestClose, modelo, serial, ubicacion }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;
    const servicesURL = process.env.REACT_APP_SERVICES_API_URL;

    const locat = useLocation();
    const queryParams = new URLSearchParams(locat.search);
    const clientID = queryParams.get("clientID");


    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //INPUTS CONTROLS
    const [name, setName] = useState(null);
    const [userName, setUserName] = useState(null);
    const [userGroup, setUserGroup] = useState(null);
    const [userMail, setUserMail] = useState(null);
    
    const [userCompany, setUserCompany] = useState(null);
    
    
    const [modelOriginal, setModelOriginal] = useState(null);
    const [model, setModel] = useState(null);
    

    const [serialNumberOriginal, setSerialNumberOriginal] = useState(null);
    const [serialNumber, setSerialNumber] = useState(null);

    const [locationOriginal, setLocationrOriginal] = useState(null);
    const [location, setLocation] = useState(null);



    const [options_model, setOptionsModel] = useState([]);


    const editSerial = async () => {

        //MAIN VALIDATION
        if(!model || !serialNumber){

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Debe indicar Modelo y Serial.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }


        //ELIMINAR EL MODELO
        let endpoint = "eliminarSerial?clienteId=" + clientID + "&serial=" + serialNumberOriginal;
                    
        fetch(servicesURL + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}

        }).then((response)=>{

           
            //REQUEST
            endpoint = "addSerial?clienteId=" + clientID + "&modelo=" + model.label + "&serial=" + serialNumber;

            fetch(servicesURL + endpoint,
            {
                method: "POST",
                headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
                body: ""

            }).then((response)=>{

                let responseContent = response;

                if(responseContent.status == 403){

                    Swal.fire({
                        title: "Error!",
                        text: responseContent.statusText,
                        icon: "error",
                        confirmButtonText: "OK"
                    });

                    return;

                } else if(responseContent.status == 500){

                    //Show message sweet alert
                    Swal.fire({
                        title: "Error!",
                        text: responseContent.statusText,
                        icon: "error",
                        confirmButtonText: "OK"
                    });

                    return;


                } else if(responseContent.status == 200){

                
                    //UPDATE LOCATION IF EXISTS
                    if(location) {

                        //REQUEST
                        endpoint = "editLocation?clientId=" + clientID + "&serialActual=" + serialNumber + "&ubicacionNueva=" + location;

                        fetch(servicesURL + endpoint,
                        {
                            method: "PUT",
                            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
                            body: ""
                        }).then(()=>{})


                    } //END IF LOCATION


                    //Show message sweet alert
                    Swal.fire({
                        title: "¡Éxito!",
                        text: "Operación realizada exitosamente.",
                        icon: "success",
                        confirmButtonText: "OK"
                    }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }});

                    //CLOSE MODAL
                    requestClose(false);


                } //END ELSEIF

            }); //END FETCH

        }); //END FETCH

    } //END METHOD
    
    const getModelsByCustomer = async () => {

        
        if(clientID){
            
            const endpoint = "getModels?clienteId=" + clientID;
            console.log(servicesURL + endpoint);

            const response = await fetch(servicesURL + endpoint,
            {
                method: "GET",
                headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
            });

            const responseContent = await response.json();

            let optionItems = [];

            let counter = 1;
            responseContent.forEach((item)=>{

                let node = {
                    value: counter,
                    label: item
                }

                optionItems.push(node);

                counter++;
            });
            

            setModel(null);
            setOptionsModel(optionItems);

        } //END IF


    } //END FUNCTION



    const onModalShow = () => {

       //GET MODELS
        getModelsByCustomer(); 


        //
        setSerialNumberOriginal(serial);
        setSerialNumber(serial);
        

        //
        setLocationrOriginal(ubicacion);
        setLocation(ubicacion);

       

    } //END FUNCTION

    useEffect(()=>{ 

        //console.log(options_model);
        //console.log(options_model.find(opt => opt.label === modelo));

        //SET CURRENT MODEL
        setModel(options_model.find(opt => opt.label === modelo));
        
    }, [options_model]);

    

    return (
        <>
        <Modal show={show} onShow={onModalShow} onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Editar Equipo (Serial y Ubicacion)</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col xs={12}>
                            <Form.Group>
                                <Form.Label className={'newOrderlabels'}>Modelo</Form.Label>
                                <Select 
                                    style={{fontSize:"14px"}}
                                    options={options_model}
                                    placeholder="-- Selecciona un Modelo --"
                                    onChange={(selectedOption) => setModel(selectedOption)}
                                    value={model} // acá va el objeto completo
                                    >
                                </Select>
                                <br />
                            </Form.Group>
                        </Col>

                        <Col xs={12}>
                            <Form.Group>
                                <Form.Label className={'newOrderlabels'}>Serial</Form.Label>
                                <Form.Control 
                                type="text" 
                                placeholder="Serial del equipo" 
                                maxLength={200} 
                                value={serialNumber}
                                onChange={(event)=> {setSerialNumber(event.target.value)}} /><br />
                            </Form.Group>
                        </Col>

                        <Col xs={12}>
                            <Form.Group>
                                <Form.Label className={'newOrderlabels'}>Ubicación</Form.Label>
                                <Form.Control 
                                type="text" 
                                placeholder="Ubicacion del equipo" 
                                maxLength={200} 
                                value={location}
                                onChange={(event)=> {setLocation(event.target.value)}} /><br />
                            </Form.Group>
                        </Col>

                    </Row>
                </Form>

            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
             <Button 
                variant="success" 
                size='sm'
                onClick={editSerial}>
                    Editar Equipo
            </Button>

            </Modal.Footer>
        </Modal>
        </>
    );
}

export default EditSerialModal;